import axios from 'axios'
import {
  UserModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  GetTypeModuleDto,
  MasterModel,
  ResponseObjectURL,
  TableResumen,
  ProfileBodyModel,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getUser(dto: UserModel, page: number) {
  return axios.post<ResponseObjectPaginated<UserModel[]>>(`${BASEURL}/user/getAll/${page}`, dto)
}

export function getUserById(dto: any) {
  return axios.get<ResponseObject<UserModel>>(`${BASEURL}/user/getInformationById?userId=${dto}`)
}

export function createUser(dto: UserModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/User`, dto)
}

export function deleteUser(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/User?id=${dto}`)
}

export function updateUser(dto: UserModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/User`, dto)
}

export function getMasterService(dto: GetTypeModuleDto, data: any = {}) {
  return axios.post<ResponseObjectPaginated<MasterModel[]>>(`${BASEURL}/master/getAll`, data, {
    params: dto,
  })
}

// OPTIONS

export function getProfileByUser(body: ProfileBodyModel = {}, page: number, size: number = 10) {
  return axios.post<ResponseObjectPaginated<UserModel[]>>(
    `${BASEURL}/profile/getAllProfilesByUser?pageNumber=${page}&size=${size}`,
    body,
  )
}

export function saveProfileByUser(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/assingProfilesToUser`, dto)
}
export function editProfileByUser(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/editProfilesToUser`, dto)
}
export function deleteProfileByUser(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/profile/deleteProfilesToUser`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateUser() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/user/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function downloadTemplateAutomaticUser() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/user/downloadTemplateBulkLoadStandar_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveUser(dto: any, bulkLoadId?: string) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(
    `${BASEURL}/user/bulkLoad?bulkLoadId=${bulkLoadId}`,
    dto,
    {
      timeout: 240000,
    },
  )
}

export function uploadMasiveAutomaticUser(dto: any, bulkLoadId?: string) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(
    `${BASEURL}/user/bulkLoadStandar?bulkLoadId=${bulkLoadId}`,
    dto,
    {
      timeout: 240000,
    },
  )
}
export function downloadTemplateUpdateUser() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/user/downloadTemplateBulkLoadUpdate_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
export function uploadUpdateMasiveUser(dto: any, bulkLoadId?: string) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(
    `${BASEURL}/user/bulkLoadUpdate?bulkLoadId=${bulkLoadId}`,
    dto,
    {
      timeout: 240000,
    },
  )
}
// FIN ---- SERVICIOS MASIVE

// Reset Password
export function forceResetPassword(dto: any) {
  return axios.get<ResponseObject<ResponseCRUD>>(`${BASEURL}/user/resetUser?userId=${dto.userId}`)
}

// Create User from Relay
export function newFromRelay(dto: any) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/user/newFromRelay`, dto)
}